<template>
      <div>
        <b-icon v-if="data.state == false" icon="x-octagon" variant="danger" animation="throb" font-scale="8" />
        <b-icon v-if="data.state ==true" icon="check" variant="success" animation="throb" font-scale="8" />
       
        <hr>
        <h3 class="mb-0">  {{$t('general.sure')}} </h3>
        <p v-if="data.state == false"> {{data.user.name}} 
            {{$t('user.actions.deactivateUser')}}
        </p>
        <p v-if="data.state ==1"> {{data.user.name}} 
            {{$t('user.actions.activateUser')}}
        </p>
   </div>
</template>

<script>
    export default {
        name: "SetStateCustomer",
//setState        
        props:{
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String
        },
         watch: {
            save: async function(data){
                if(data){
                      let data = {
                            userId: this.data.user.id,
                            state: this.data.state,
                        }
                        await this.$store.dispatch('userSetState', data)
                        await this.$store.dispatch('user_list' )
                        this.saveState(false)
                        this.modalEvent(false)
                }
                this.saveState(false)
                this.modalEvent(false)

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Users/modals/SetStateUser.vue